import React from 'react';
import { Answer } from '../../gds-api-client';
import styles from './styles.scss';
import { GuestWeddingQuestions } from '../interfaces';

interface QuestionAndAnswersProps {
  questions: GuestWeddingQuestions;
  answers: Answer[] | null;
}

const QuestionsAndAnswers: React.FC<QuestionAndAnswersProps> = ({ questions, answers }) => {
  if (!questions || !questions.length) return null;
  return (
    <div className={styles.questionsAnswers}>
      {questions?.map(q => {
        const answer = answers?.find(a => a.questionId === q.id);

        // get text from answer option or answer text
        // else if no answer show --
        const withText =
          answer && answer.optionId ? q?.options?.find(o => o?.id === answer.optionId) || answer : answer;
        const answerText = withText?.text || <>&ndash;&ndash;</>;

        return (
          <div key={q.id} className={styles.qa}>
            <div className={styles.questionText}>{q.text || ''}</div>
            <div className={styles.answerText}>{answerText}</div>
          </div>
        );
      })}
    </div>
  );
};

export default QuestionsAndAnswers;
